const getTotalProfit = (
  usdc_amount: number,
  hedge_ratio: number,
  _duration: number,
  _range: number,
  k: number,
  _marketPrice: number,
  feeApy: number,
  eth_borrow_apy: number
) => {
  const entryPrice = _marketPrice;
  const price = entryPrice * k;
  const max_price = entryPrice * (1 + _range / 100);
  const min_price = entryPrice / (1 + _range / 100);
  const max_k = max_price / entryPrice;
  const min_k = min_price / entryPrice;

  const hodl_a_amount = (usdc_amount * (1 + hedge_ratio)) / 2 / entryPrice;
  const hodl_b_amount = (usdc_amount * (1 + hedge_ratio)) / 2;

  const Lx =
    entryPrice > max_price
      ? hodl_b_amount / (entryPrice ** 0.5 - min_price ** 0.5)
      : (hodl_a_amount * (entryPrice ** 0.5 * max_price ** 0.5)) /
        (max_price ** 0.5 - entryPrice ** 0.5);

  const entry_total = hodl_a_amount * entryPrice + hodl_b_amount;

  const get_v3_a_amount = () => {
    let amount;
    if (k < min_k) {
      amount =
        (Lx * (max_price ** 0.5 - min_price ** 0.5)) /
        (max_price ** 0.5 * min_price ** 0.5);
    } else if (k > max_k) {
      amount =
        (Lx * (max_price ** 0.5 - max_price ** 0.5)) /
        (max_price ** 0.5 * max_price ** 0.5);
    } else {
      amount =
        (Lx * (max_price ** 0.5 - price ** 0.5)) /
        (max_price ** 0.5 * price ** 0.5);
    }
    return amount;
  };

  const get_v3_b_amount = () => {
    let amount;
    if (k < min_k) {
      amount = Lx * (min_price ** 0.5 - min_price ** 0.5);
    } else if (k > max_k) {
      amount = Lx * (max_price ** 0.5 - min_price ** 0.5);
    } else {
      amount = Lx * (price ** 0.5 - min_price ** 0.5);
    }
    return amount;
  };

  const v3_a_amount = get_v3_a_amount();
  const v3_a_value = v3_a_amount * price;
  const v3_b_amount = get_v3_b_amount();
  const v3_total = v3_a_value + v3_b_amount;

  const eth_borrow_amount = (usdc_amount * hedge_ratio) / entryPrice;
  const fee_income =
    ((hodl_a_amount * entryPrice + hodl_b_amount) * feeApy * _duration) / 365;
  const lending_position = eth_borrow_amount * (entryPrice - price);
  const lending_interest_cost =
    (-(eth_borrow_amount * eth_borrow_apy * _duration) / 365) * price;

  const total_profit =
    v3_total -
    entry_total +
    fee_income +
    lending_position +
    lending_interest_cost;

  return total_profit;
};

const getTotalProfitWithStopLossPrice = (
  usdc_amount: number,
  hedge_ratio: number,
  _duration: number,
  _range: number,
  k: number,
  _marketPrice: number,
  feeApy: number,
  eth_borrow_apy: number,
  stopLossLowerPrice: number,
  stopLossUpperPrice: number
) => {
  const estiProfit = getTotalProfit(
    usdc_amount,
    hedge_ratio,
    _duration,
    _range,
    k,
    _marketPrice,
    feeApy,
    eth_borrow_apy
  );

  const stopLossUpperPriceProfit = getTotalProfit(
    usdc_amount,
    hedge_ratio,
    _duration,
    _range,
    stopLossUpperPrice / _marketPrice, // k
    _marketPrice,
    feeApy,
    eth_borrow_apy
  );

  const stopLossLowerPriceProfit = getTotalProfit(
    usdc_amount,
    hedge_ratio,
    _duration,
    _range,
    stopLossLowerPrice / _marketPrice, // k
    _marketPrice,
    feeApy,
    eth_borrow_apy
  );

  if (k < 1) {
    return !stopLossLowerPrice
      ? estiProfit
      : Math.max(estiProfit, stopLossLowerPriceProfit);
  } else if (k > 1) {
    return !stopLossUpperPrice
      ? estiProfit
      : Math.max(estiProfit, stopLossUpperPriceProfit);
  } else {
    return estiProfit;
  }
};

export default getTotalProfitWithStopLossPrice;
